import { useTranslation } from "@opendash/i18n";
import { Form, FormItemProps } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { SaveTicketValues } from "../..";
import { useFieldConfig } from "../../hooks/useFieldConfig";
import { MediaInputIcon } from "./media/MediaInputIcon";

type Props = {
  type: "dropdown";
} & FormItemProps<SaveTicketValues>;

export const MediaInputItem = observer((props: Props) => {
  const t = useTranslation();
  const config = useFieldConfig("media");

  if (config && config.hidden) return <></>;

  const label =
    config?.label === "-"
      ? ""
      : config?.label || t("maintenance:ticket.create.media.label");

  return (
    <Form.Item<SaveTicketValues>
      name="media"
      label={label}
      help={config?.help}
      rules={[
        {
          required: config?.required,
          message: t("maintenance:ticket.create.media.error.empty"),
        },
      ]}
      {...props}
    >
      {props.type === "dropdown" && <MediaInputIcon />}
    </Form.Item>
  );
});
